import { Reveal } from "./Reveal";

const jobs = [
  {
    img: "/gallery/bomba.jpg",
    title: "Bomba de combustível — troca no local",
    tag: "Todas as marcas · Peça a bordo",
  },
  {
    img: "/gallery/arranque.jpg",
    title: "Revisão de motor de arranque",
    tag: "Reparo feito na hora",
  },
  {
    img: "/gallery/alternador.jpg",
    title: "Revisão de alternador",
    tag: "Teste de carga completo",
  },
];

const jobs2 = [
  {
    img: "/gallery/lampadas.jpg",
    title: "Revisão de lâmpadas",
    tag: "Faróis · Lanternas · LED",
  },
  {
    img: "/gallery/pane.jpg",
    title: "Pane elétrica — diagnóstico completo",
    tag: "Fusíveis · Relés · Chicote",
  },
  {
    img: "/gallery/bateria.jpg",
    title: "Recarga e troca de bateria",
    tag: "Partida garantida no local",
  },
];

export default function Gallery() {
  return (
    <section id="galeria" data-testid="gallery-section" className="relative py-24 sm:py-32 bg-[#0b0d10]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#e8112d] font-semibold mb-4">
            Atendimento a pronta entrega
          </p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
            Na rua, na madrugada, resolvemos
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl">
          {jobs.map((j, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`gallery-item-${i + 1}`}
                className="group relative overflow-hidden rounded-2xl border border-white/5 hover:border-[#e8112d]/40 transition-all duration-500"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={j.img}
                    alt={j.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent" />
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_50%_20%,rgba(232,17,45,0.22),transparent_65%)]" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#c7cbd4] mb-2">{j.tag}</p>
                  <p className="text-sm font-semibold text-white leading-snug">{j.title}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl">
          {jobs2.map((j, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`gallery-item-${i + 4}`}
                className="group relative overflow-hidden rounded-2xl border border-white/5 hover:border-[#e8112d]/40 transition-all duration-500"
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={j.img}
                    alt={j.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent" />
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_50%_20%,rgba(232,17,45,0.22),transparent_65%)]" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#c7cbd4] mb-2">{j.tag}</p>
                  <p className="text-sm font-semibold text-white leading-snug">{j.title}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
